import { Model, Prompt } from '../../../../Types';
import AdminViewCard from '../../../Utility/AdminViewCard';
import TabHeadline from './TabHeadline';
import { PaginationListType } from '../../../../Types/PaginationParams';
import { modelService } from '../../../../Services/modelService';
import { promptService } from '../../../../Services/promptService';
import PaginatedView from '../../../Utility/PaginatedView';

interface ModelTabProps {
    prompt: Prompt;
    i18n: any;
    handleDropdownChange: any;
    isUserPrompt: boolean;
}

function ModelTab({ prompt, i18n, handleDropdownChange, isUserPrompt }: ModelTabProps) {
    return (
        <div className="w-full">
            <TabHeadline title={i18n.translate({ id: 'tabs.model.title', sourceName: 'Prompt' })} />

            <PaginatedView
                listType={PaginationListType.Models}
                itemsFunction={
                    !isUserPrompt
                        ? modelService.getModelsByPage
                        : async () => {
                              return {
                                  data: await promptService.getModels(isUserPrompt),
                                  totalCount: 2,
                              };
                          }
                }
                itemsPerPage={12}
                renderItem={(model: Model, index: number) => (
                    <AdminViewCard
                        key={model.identifier}
                        identifier={model.identifier}
                        title={model.title}
                        image={model.image}
                        handleChangeFunction={handleDropdownChange}
                        isActive={prompt.model === model.identifier}
                    />
                )}
                listClassName="grid grid-cols-[repeat(auto-fill,minmax(theme(spacing.60),1fr))] gap-3"
            >
                {({ list, filter }) => (
                    <>
                        {filter}
                        {list}
                    </>
                )}
            </PaginatedView>
        </div>
    );
}

export default ModelTab;
